import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=18812fdf&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=18812fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18812fdf",
  null
  
)

export default component.exports